import { actions } from '@/common/utils/actionLifecycle';

const actionStateState = {
  actions,
};

const actionStateMutations = {};

const actionStateActions = {};

const actionStateGetters = {};

export default {
  namespaced: true,
  state: { ...actionStateState },
  mutations: { ...actionStateMutations },
  actions: { ...actionStateActions },
  getters: { ...actionStateGetters },
};
